import React, { useContext, useLayoutEffect, useState } from 'react';
import * as S from './styles';
import SimpleInput from 'components/SimpleInput';
import DynamicPageContext from 'context/DynamicPage';
import { verifyIfFormCanSave } from './functions';

export interface DataFormProps {
	paddingTop: number;
	paddingBottom: number;
	videoLink: string;
}

const initialState: DataFormProps = {
	paddingTop: 0,
	paddingBottom: 0,
	videoLink: ''
};

export default function InputsMediaYoutube() {
	const {
		moduleInSavingMode,
		setModuleInSavingMode,
		setCanSaveModuleOnBack,
		setMessageErrorForm,
		moduleOnPhoneToEdit,
		setModuleOnPhoneToEdit
	} = useContext(DynamicPageContext);
	const [dataForm, setDataForm] = useState<DataFormProps>(initialState);

	useLayoutEffect(() => {
		//se esta criando um novo componente
		if (moduleInSavingMode !== null) {
			setModuleInSavingMode((obj) => {
				if (obj) {
					return { ...obj, data: dataForm };
				}
				return obj;
			});
		} else {
			//se esta editando um componente
			setModuleOnPhoneToEdit((obj) => {
				if (obj) {
					return { ...obj, data: dataForm };
				}
				return obj;
			});
		}

		verifyIfFormCanSave(dataForm, setCanSaveModuleOnBack, setMessageErrorForm);
	}, [dataForm]);

	//se estiver em edição aqui pega os dados do item editado
	useLayoutEffect(() => {
		if (moduleOnPhoneToEdit !== null && moduleInSavingMode === null) {
			setDataForm((obj) => ({ ...obj, ...moduleOnPhoneToEdit.data }));
		}
	}, []);

	return (
		<S.container>
			<SimpleInput
				label="Video Link"
				initialValue={dataForm.videoLink}
				getValue={(value: string) => {
					setDataForm((obj) => ({ ...obj, videoLink: value }));
				}}
			/>

			<SimpleInput
				label="Padding Top"
				typeInput="number"
				initialValue={dataForm.paddingTop}
				getValue={(value: string) => {
					setDataForm((obj) => ({ ...obj, paddingTop: parseInt(value) }));
				}}
			/>

			<SimpleInput
				label="Padding Bottom"
				typeInput="number"
				initialValue={dataForm.paddingBottom}
				getValue={(value: string) => {
					setDataForm((obj) => ({ ...obj, paddingBottom: parseInt(value) }));
				}}
			/>
		</S.container>
	);
}
